export default "__VITE_ASSET__CcYUSn34__"